'use client';
import { REFERRAL_VOUCHER_COOKIE_EXPIRATION } from '@finn/ua-constants';
import { CookieKeys } from '@finn/ui-utils';
import Cookies from 'js-cookie';
import { redirect } from 'next/navigation';
import { useEffect } from 'react';

export const CookieSetter = ({
  cookieObj,
  withRedirect,
}: {
  cookieObj?: object;
  withRedirect: boolean;
}) => {
  useEffect(() => {
    if (cookieObj) {
      Cookies.set(CookieKeys.REFERRAL_VOUCHER_CODE, JSON.stringify(cookieObj), {
        expires: REFERRAL_VOUCHER_COOKIE_EXPIRATION,
      });
    }

    if (withRedirect) {
      redirect('/subscribe');
    }
  }, [cookieObj, withRedirect]);

  return null;
};
